module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Select a report to view:\n  "), _c('ul', [_c('li', [_vm._v("\n      >\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'sales-by-pack'
      }
    }
  }, [_vm._v("Sales by Pack")])], 1)]), _vm._v(" "), (_vm.isSuperUser) ? _c('div', [(_vm.loadComplete) ? _c('div', [_c('div', {
    staticClass: "chart-header"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataType),
      expression: "dataType"
    }],
    staticClass: "title is-3 select chart-select",
    attrs: {
      "name": "dataType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "order_comparison"
    }
  }, [_vm._v("Order Activity")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "revenue_comparison"
    }
  }, [_vm._v("Revenue")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "payment_comparison"
    }
  }, [_vm._v("Payment Type")])]), _vm._v(" "), _c('div', {
    staticClass: "chart-options"
  }, [_c('div', {
    staticClass: "date-range"
  }, [_vm._v("\n            Range\n            "), _c('input', {
    staticClass: "input date-input",
    attrs: {
      "type": "text",
      "name": "activity_start",
      "id": "activity_start"
    },
    domProps: {
      "value": _vm.activityStart
    }
  }), _vm._v("\n            -\n            "), _c('input', {
    staticClass: "input date-input",
    attrs: {
      "type": "text",
      "name": "activity_end",
      "id": "activity_end"
    },
    domProps: {
      "value": _vm.activityEnd
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "user-select": "none"
    }
  }, [(!_vm.reloadActivityChart) ? _c('order-chart', {
    attrs: {
      "dataType": _vm.dataType,
      "startDay": _vm.activityStart,
      "endDay": _vm.activityEnd
    }
  }) : _vm._e()], 1)]) : _c('div', [_vm._v("\n      loading...\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2960bf03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/reports/Summary.vue
// module id = 515
// module chunks = 0